export default __webpack_public_path__ + "static/breadcrumbs-overflow-dark-d693cded01e46b56eb7a8f53b101baf1.png";